import { createSvgIcon } from '@mui/material';

const IconPunto99 = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57.353"
    height="67.493"
    viewBox="0 0 57.353 67.493"
  >
    <g id="Group_4643" data-name="Group 4643" transform="translate(-706.82 -307.521)">
      <g id="Group_4606" data-name="Group 4606" transform="translate(706.82 307.521)">
        <circle
          id="Ellipse_832"
          data-name="Ellipse 832"
          cx="8.169"
          cy="8.169"
          r="8.169"
          transform="translate(18.201 22.791)"
          fill="#85c440"
        />
        <path
          id="Path_3442"
          data-name="Path 3442"
          d="M759.573,323.749l4.6-4.6-1.912-2.747a44.122,44.122,0,0,0-6.937-6.962l-2.737-1.919-4.621,4.621,3.845,3.845L749.8,318a26.371,26.371,0,1,0-28.521,44.011l6.641-6.592A17.741,17.741,0,1,1,746.6,350.09l-18.77,18.839,6.086,6.085L752.628,356.3a26.366,26.366,0,0,0,1.016-34.459l2.012-2.01Z"
          transform="translate(-706.82 -307.521)"
          fill="#85c440"
        />
      </g>
    </g>
  </svg>,
  'IconPunto99',
);

export default IconPunto99;
